/** Fixed card height; keep in sync with `.user-request-card` in styles.css */
export const USER_REQUEST_CARD_HEIGHT = 620;

/** Space between virtual list rows */
export const USER_REQUEST_CARD_LIST_GAP = 12;

export const USER_REQUEST_CARD_ITEM_SIZE =
  USER_REQUEST_CARD_HEIGHT + USER_REQUEST_CARD_LIST_GAP;
